import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 16,
	viewBox: "0 0 19 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.22107 3.5366C9.22107 2.87708 9.47471 2.21757 9.982 1.76098C10.4893 1.25366 11.098 1 11.7575 1H16.8304C16.9826 1 17.1348 1.05073 17.287 1.20293C17.3884 1.30439 17.4899 1.50732 17.4899 1.65952V11.8059C17.4899 11.9581 17.4392 12.1103 17.287 12.2625C17.1855 12.364 16.9826 12.4654 16.8304 12.4654H11.7575C11.098 12.4654 10.4386 12.7191 9.982 13.2264C9.52544 13.683 9.22107 14.3425 9.22107 15.002",
		stroke: "currentColor",
		strokeWidth: 2.00013,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.00012 11.7552C1.00012 11.9074 1.05085 12.0596 1.20304 12.2118C1.3045 12.3132 1.50741 12.4147 1.6596 12.4147H6.7325C7.39198 12.4147 8.05145 12.6684 8.50802 13.1757C8.96458 13.6323 9.26895 14.2918 9.26895 14.9513V3.5366C9.26895 2.87708 9.01531 2.21757 8.50802 1.76098C8.00073 1.25366 7.39198 1 6.68177 1H1.60887C1.45668 1 1.3045 1.05073 1.20304 1.20293C1.05085 1.30439 1.00012 1.45659 1.00012 1.60878V11.7552Z",
		stroke: "currentColor",
		strokeWidth: 2.00013,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgBookIcon;
